export function MenuInner() {
	return <></>;
}
